import { SearchBar as SearchBarComponent } from '@tribeplatform/react-components/Search'

import { useQuery } from '../../lib/useQuery'

export const SearchBar = ({ autoFocus = false }) => {
  const { query, type } = useQuery()

  return <SearchBarComponent autoFocus={autoFocus} query={query} type={type} />
}
